import { ADDIN_SESSION_COOKIE_NAME, type CopilotDefinition } from "./types";

export const wordCopilot: CopilotDefinition = {
  copilotId: "word",
  displayName: "Word",
  surfaceLabel: "Microsoft Word add-in",
  surfaces: ["word-add-in"],
  capabilities: ["word"],
  embedded: {
    "word-add-in": { sessionCookieName: ADDIN_SESSION_COOKIE_NAME },
  },
  display: {
    description:
      "Draft, edit, and refine documents with AI assistance. Once Word opens, find the add-in on the Home ribbon tab — click the Magnus button.",
    category: "productivity",
    icon: "file-text",
    color: "bg-blue-600",
    initial: "W",
  },
  launch: {
    kind: "protocol-handler",
    uriTemplate: "ms-word:nft|u|{origin}/assets/office-addin/blank_rev_1.docx",
  },
};
